import React from "react";
import { Button, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    width: "100%",
    // height: "100%",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    boxSizing: "border-box",
    padding: "25px",
    height: "450px",
    maxWidth: "400px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    margin: 0,
    fontSize: "18px",
    fontWeight: 700,
    color: "#1e293b", // slate-800
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b", // slate-500
    margin: 0,
  },
  badge: {
    padding: "4px 12px",
    fontSize: "12px",
    fontWeight: 600,
    color: "#fff",
    background: "#a855f7", // purple-500
    borderRadius: "9999px",
  },
  stats: {
    display: "flex",
    alignItems: "baseline",
    gap: "8px",
  },
  percentage: {
    fontSize: "28px",
    fontWeight: 700,
    WebkitBackgroundClip: "text",
    color: "transparent",
    margin: 0,
  },
  impactSubtitle: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "14px",
    fontWeight: 600,
    margin: 0,
  },
  growthColor: {
    color: "#22c55e",
  },
  declineColor: {
    color: "#ef4444",
  },
  description: {
    fontSize: "14px",
    color: "#64748b",
    margin: 0,
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tags: {
    display: "flex",
    gap: "8px",
  },
  tag: {
    padding: "4px 8px",
    fontSize: "12px",
    fontWeight: 600,
    borderRadius: "9999px",
    background: "#f1f5f9", // slate-100
    color: "#475569", // slate-600
    textTransform: "capitalize",
  },
  divider: {
    borderTop: "1px solid #e2e8f0", // slate-200
    marginTop: "auto",
    paddingTop: "16px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    textAlign: "center",
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  gridLabel: {
    margin: 0,
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  actions: {
    paddingTop: "16px",
    borderTop: "1px solid #e2e8f0",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  actionRow: {
    display: "flex",
    gap: "8px",
  },
  outlinedBtn: {
    flex: 1,
    background: "#f1f5f9",
    color: "#334155",
    fontWeight: 600,
    fontSize: "14px",
    textTransform: "none",
    "&:hover": {
      background: "#e2e8f0",
    },
  },
  primaryBtn: {
    background: "#2563eb", // primary
    color: "#fff",
    fontWeight: 600,
    fontSize: "14px",
    textTransform: "none",
    "&:hover": {
      opacity: 0.9,
    },
  },
});

const NewFlowCardPreview = (props) => {
  const { classes, flow } = props;

  return (
    <div className={classes.root}>
      {/* Header */}
      <div className={classes.header}>
        <div className={classes.titleContainer}>
          <h3 className={classes.title}>{flow.flowName}</h3>
          <p className={classes.subtitle} style={{ marginTop: "5px" }}>
            {flow.subtitle}
          </p>
        </div>
        {flow.bannerText && (
          <span
            className={classes.badge}
            style={{ backgroundColor: flow.bannerColor }}
          >
            {flow.bannerText}
          </span>
        )}
      </div>

      {/* Stats */}
      <div className={classes.stats}>
        <h4
          className={`${classes.percentage} ${
            flow.impactPercentage >= 0
              ? classes.growthColor
              : classes.declineColor
          }`}
        >
          {flow.impactPercentage > 0 ? "+" : ""}
          {flow.impactPercentage}%
        </h4>
        <div
          className={`${classes.impactSubtitle} ${
            flow.impactPercentage >= 0
              ? classes.growthColor
              : classes.declineColor
          }`}
        >
          {flow.impactPercentage >= 0 ? (
            <span
              className="material-symbols-outlined"
              style={{ fontSize: 16 }}
            >
              trending_up
            </span>
          ) : (
            <span
              className="material-symbols-outlined"
              style={{ fontSize: 16 }}
            >
              trending_down
            </span>
          )}
          {flow.subtitle}
        </div>
      </div>

      {/* Description */}
      <Tooltip title={flow.flowDescription}>
        <p className={classes.description}>{flow.flowDescription}</p>
      </Tooltip>

      {/* Tags */}
      <div className={classes.tags}>
        {flow.tags.map((tag) => {
          return <span className={classes.tag}>{tag}</span>;
        })}
      </div>

      {/* Grid Section */}
      <div className={classes.divider}>
        <div className={classes.grid}>
          {flow.outcomeHighlights.map((outcomeItem) => {
            return (
              <div className={classes.gridItem}>
                <span
                  className="material-symbols-outlined"
                  style={{ fontSize: 24, color: "#0A474C" }}
                >
                  {outcomeItem.icon}
                </span>
                <p className={classes.gridLabel}>{outcomeItem.description}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Actions */}
      <div className={classes.actions}>
        <div className={classes.actionRow}>
          <Button
            className={classes.outlinedBtn}
            onClick={() => console.log("openPreviewDrawer")}
          >
            Flow Preview
          </Button>
          <Button className={classes.outlinedBtn}>Live Demo</Button>
        </div>
        <Button variant="contained" color="primary">
          Use this Template
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles)(NewFlowCardPreview);
